import { Fragment, useState, useEffect, useRef } from "react";
import "../Bucket.scss";
import { Menu, Transition } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faLink, faPlus } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import "./sharebucket.scss";
import { toastify } from "../../components/Toast";
import Avatar from "react-avatar";
import { useNavigate } from "react-router-dom";
import BlackDismiss from "../../assets/icons/dismissButton.svg";
function ShareBucket({ closeSharePop, shareBucketId, bucketUpdate, bucketPublicShare }) {
  const [isTagOpen, setIsTagOpen] = useState(false);
  const [tagOptions, setTagOptions] = useState([]);
  const [tags, setTags] = useState([]);
  const [peopleAccess, setPeopleAccess] = useState([]);
  const [owner, setOwner] = useState({});
  const [permission, setPermission] = useState("Editor");
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const [inputValueSet, setInputValueSet] = useState("");
  const [bucketRefresh, setBucketRefresh] = useState(false);
  const [AccessUpdate, setAccessUpdate] = useState(false);
  const navigate = useNavigate();
  const tagsInputRef = useRef("");
  const filterDropDown = [
    { name: "Viewer" },
    { name: "Editor" },
    { name: "Remove Access" },
  ];

  useEffect(() => {
    const token = localStorage.getItem("token");

    axios
      .post(
        `${process.env.REACT_APP_API}team/peopleAccess-withItem`,
        {
          itemId: shareBucketId,
          itemType: "Bucket",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(function (response) {
        setPeopleAccess(response?.data?.data?.membersWithAccess?.shared || []);
        setOwner(response?.data?.data?.owner);
        setAccessUpdate(false);
      })
      .catch(function (error) {
        console.error(error);
      });
  }, [AccessUpdate, shareBucketId]);
  useEffect(() => {
    // api url

    const token = localStorage.getItem("token");

    axios
      .get(`${process.env.REACT_APP_API}team/owner-team-members`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
        setBucketRefresh(false);
        setTagOptions(response?.data?.data?.teamMembers || []);
      })
      .catch(function (error) {
        console.error(error);
      });
  }, [bucketRefresh]);
  const closePop = () => {
    closeSharePop();
  };
  const changePermission = async (id, shareBucketId, permission) => {
    const token = localStorage.getItem("token");
    // const selectedPermission = permission || selectedPermissions[userId]; // Replace 'userId' with the actual user's ID
    if (permission === "Remove Access") {
      await axios
        .post(
          `${process.env.REACT_APP_API}team/revoke-item-access`,
          { temMemberId: id, itemId: shareBucketId },

          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(function (response) {
          setBucketRefresh(true);
          toastify("success", response.data.message);
          setTagOptions(response?.data?.data?.teamMembers);
          setAccessUpdate(true);
          bucketUpdate();
        })
        .catch(function (error) {
          console.error(error);
          toastify("error", error?.response?.data?.message);
        });
    } else {
      await axios
        .post(
          `${process.env.REACT_APP_API}team/update-item-access`,
          {
            temMemberId: id,
            itemId: shareBucketId,
            permissions: permission,
          },

          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(function (response) {
          setBucketRefresh(true);
          toastify("success", response.data.message);
          setTagOptions(response?.data?.data?.teamMembers);
        })
        .catch(function (error) {
          console.error(error);
          toastify("error", error?.response?.data?.message);
        });
    }
  };
  const handleBucketLink = async () => {
    const token = localStorage.getItem("token");
    await axios
      .post(
        `${process.env.REACT_APP_API}cards/public-url`,
        {
          itemId: shareBucketId,
          isPublic: true,
          itemType: "Bucket",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(function (response) {
        closePop()
        bucketPublicShare(response?.data?.data);
        // const tempInput = document.createElement("input");
        //   tempInput.value = response?.data?.data;

        //   // Append the input element to the DOM
        //   document.body.appendChild(tempInput);

        //   // Select the input element's text and copy it to clipboard
        //   tempInput.select();
        //   document.execCommand("copy");

        //   // Remove the temporary input element
        //   document.body.removeChild(tempInput);
        //   toastify("success", response.data.message);
        // setTagOptions(response?.data?.data?.teamMembers);
        // setBucketRefresh(true);
        // bucketUpdate();
        // setEmail([]);
      })
      .catch(function (error) {
        console.error(error);
        toastify("error", error?.response?.data?.message);
      });
  }
  const handleBucketShare = async () => {
    if (tags.length !== 0) {
      const token = localStorage.getItem("token");

      await axios
        .post(
          `${process.env.REACT_APP_API}team/shareItem-withTeamMember`,
          {
            userEmails: tags,
            itemId: shareBucketId,
            permissions: permission,
            itemType: "Bucket",
          },

          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(function (response) {
          // closePop()
          toastify("success", response.data.message);
          // setTagOptions(response?.data?.data?.teamMembers);
          setBucketRefresh(true);
          setAccessUpdate(true);
          setInputValueSet("");
          setTags([]);
          bucketUpdate();
          // setEmail([]);
        })
        .catch(function (error) {
          console.error(error);
          toastify("error", error?.response?.data?.message);
        });
    }
  };
  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      const newTag = selectedOption?.email;
      if (!tags.includes(newTag)) {
        setTags([...tags, newTag]);
        handleTagsChange([...tags, newTag]);
        handleBlur();
      }
    }
  };
  const handleBlur = () => {
    setIsTagOpen(false);
  };
  const handleTagsChange = (newTags, value) => {
    setTags(newTags);
  };

  const handleAddMember = () => {
    // navigate("/app/settings?tab=teamMembers");
    navigate("/app/manageTeam");
  };
  const handleFocus = (e) => {
    e.stopPropagation();

    tagsInputRef.current.focus();
    setIsTagOpen(true);
  };
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const filteredTagOptions = tagOptions.filter((option) => {
    const inputValue = inputValueSet.toLowerCase().trim();
    const [searchFirstName, searchLastName] = inputValue.split(" ");

    return (
      (searchFirstName && option.firstName.toLowerCase().startsWith(searchFirstName)) ||
      (searchLastName && option.lastName.toLowerCase().startsWith(searchLastName)) ||
      (inputValue.length === 1 &&
        (option.firstName.toLowerCase().startsWith(inputValue) ||
          option.lastName.toLowerCase().startsWith(inputValue))) ||
      option.email.toLowerCase().includes(inputValue)
    );
  });

  return (
    <div className="share-bucket-modal__overlay" onClick={closeSharePop}>
      <section
        aria-labelledby="share-bucket-title"
        aria-modal="true"
        className="share-bucket-modal"
        role="dialog"
        onClick={(event) => {
          setIsTagOpen(false);
          event.stopPropagation();
        }}
      >
        <header className="share-bucket-modal__header">
          <div>
            <h2 id="share-bucket-title">Share bucket</h2>
            <p>Invite your team or manage who can access this bucket.</p>
          </div>
          <div className="share-bucket-modal__actions">
            <button aria-label="Create share link" className="share-bucket-modal__icon-button" onClick={handleBucketLink} type="button">
              <FontAwesomeIcon icon={faLink} />
            </button>
            <button aria-label="Close share dialog" className="share-bucket-modal__icon-button" onClick={closeSharePop} type="button">
              <img src={BlackDismiss} alt="" />
            </button>
          </div>
        </header>

        {tagOptions.length ? (
          <section className="share-bucket-modal__invite">
            <label htmlFor="share-bucket-members">Invite people</label>
            <p>Choose one or more team members and set their permission.</p>
            <div className="share-bucket-modal__invite-controls">
              <div className="share-bucket-modal__member-input" onClick={handleFocus}>
                <TagsInput
                  ref={tagsInputRef}
                  id="share-bucket-members"
                  inputProps={{ id: "share-bucket-members" }}
                  placeholder="Search team members"
                  value={tags}
                  onChange={handleTagsChange}
                  inputValue={inputValueSet}
                  onChangeInput={setInputValueSet}
                />
              </div>
              {tags.length > 0 && (
                <label className="share-bucket-modal__permission-select">
                  <span className="sr-only">Permission for selected members</span>
                  <select value={permission} onChange={(event) => setPermission(event.target.value)}>
                    <option value="Editor">Editor</option>
                    <option value="Viewer">Viewer</option>
                  </select>
                </label>
              )}
            </div>
            {isTagOpen && (
              <ul className="share-bucket-modal__suggestions" onClick={(event) => event.stopPropagation()}>
                {filteredTagOptions.length ? (
                  filteredTagOptions.map((option) => (
                    <li key={option.email}>
                      <button onClick={() => handleSelectChange(option)} type="button">
                        <span>{option.firstName} {option.lastName}</span>
                        <small>{option.email}</small>
                      </button>
                    </li>
                  ))
                ) : (
                  <li className="share-bucket-modal__empty-state">No matching team members.</li>
                )}
              </ul>
            )}
          </section>
        ) : (
          <section className="share-bucket-modal__empty-invite">
            <div>
              <h3>Invite your team first</h3>
              <p>Add team members before sharing this bucket.</p>
            </div>
            <button className="share-bucket-modal__secondary-button" onClick={handleAddMember} type="button">
              <FontAwesomeIcon icon={faPlus} /> Add members
            </button>
          </section>
        )}

        <section className="share-bucket-modal__access">
          <div className="share-bucket-modal__section-heading">
            <h3>People with access</h3>
            <span>{peopleAccess?.length || 0} shared</span>
          </div>
          <div className="share-bucket-modal__people-list">
            <div className="share-bucket-modal__person">
              <div className="share-bucket-modal__person-info">
                {owner?.imageUrl ? (
                  <img alt={`${owner?.firstName || ""} ${owner?.lastName || ""}`.trim()} src={owner.imageUrl} />
                ) : (
                  <Avatar className="share-bucket-modal__avatar" name={`${owner?.firstName || ""} ${owner?.lastName || ""}`} size="44" round />
                )}
                <div>
                  <strong>{owner?.firstName} {owner?.lastName} <span>(you)</span></strong>
                  <small>{owner?.email}</small>
                </div>
              </div>
              <span className="share-bucket-modal__owner-badge">Owner</span>
            </div>

            {peopleAccess?.map((people) => {
              const person = people?.sharedWith;
              const personId = person?._id;
              if (!person) return null;

              return (
                <div className="share-bucket-modal__person" key={personId || person.email}>
                  <div className="share-bucket-modal__person-info">
                    {person.imageUrl ? (
                      <img alt={`${person.firstName || ""} ${person.lastName || ""}`.trim()} src={person.imageUrl} />
                    ) : (
                      <Avatar className="share-bucket-modal__avatar" name={`${person.firstName || ""} ${person.lastName || ""}`} size="44" round />
                    )}
                    <div>
                      <strong>{person.firstName} {person.lastName}</strong>
                      <small>{person.email}</small>
                    </div>
                  </div>
                  <Menu as="div" className="share-bucket-modal__permission-menu">
                    <Menu.Button className="share-bucket-modal__permission-button">
                      {selectedPermissions[personId] || people.permissions}
                      <FontAwesomeIcon icon={faChevronDown} />
                    </Menu.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="share-bucket-modal__permission-options">
                        {filterDropDown.map((item) => (
                          <Menu.Item key={item.name}>
                            {({ active }) => (
                              <button
                                className={classNames(active && "is-active", item.name === "Remove Access" && "is-destructive")}
                                onClick={() => {
                                  setSelectedPermissions({ ...selectedPermissions, [personId]: item.name });
                                  changePermission(personId, shareBucketId, item.name);
                                }}
                                type="button"
                              >
                                {item.name}
                              </button>
                            )}
                          </Menu.Item>
                        ))}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              );
            })}
          </div>
        </section>

        <footer className="share-bucket-modal__footer">
          <button className="share-bucket-modal__primary-button" disabled={!tags.length} onClick={handleBucketShare} type="button">
            Share with {tags.length ? `${tags.length} ${tags.length === 1 ? "person" : "people"}` : "team"}
          </button>
        </footer>
      </section>
    </div>
  );
}

export default ShareBucket;
